<div class="prompt-wrapper">
  <h1 mat-dialog-title>Are you sure?</h1>
  <mat-dialog-content *ngIf="text">
    <p>{{ text }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{'commonPhrases.yes' | translate}}</button>
    <!-- Can optionally provide a result for the closing dialog. -->
    <button mat-button color="primary" [mat-dialog-close]="true">{{ 'commonPhrases.no' | translate }}</button>
  </mat-dialog-actions>
</div>

